export const getFileExtension = (name: string) => {
  const split = name.split('.');
  if (split.length === 1) {
    return '';
  }
  return split.slice(-1)[0];
};
